import { Job } from "@models/job.model";
import { JobSerializer } from "@models/serializers/jobSerializer";
import { httpRequest } from "../../http";

export class CommandImportPerformance {
    async run(days: number = 1): Promise<Job> {
        const response = await httpRequest<any>(
            `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/import-performance/`,
            {
                method: "POST",
                body: { days },
            }
        );
        return new JobSerializer().deserialize(response);
    }
}
